import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivitySpeciesTypeForm from '../../../components/forms/ActivitySpeciesTypeForm';
import { useActivitySpeciesTypeApi } from '../../../hooks/useActivitySpeciesTypeApi';
import { useNavigate } from 'react-router-dom';
import { ActivitySpeciesTypeDTO } from '../../../services/apiClient';

const ActivitySpeciesTypeCreate: React.FC = () => {
  const { create, isLoading } = useActivitySpeciesTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Specieses', href: '/admin/activityspeciesestype' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ActivitySpeciesTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/activityspeciesestype');
    } catch (error) {
      console.error('Error creating ActivitySpeciesType:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activityspeciesestype"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ActivitySpeciesType.Edit'
    >
        <ActivitySpeciesTypeForm
          initialValues={{} as ActivitySpeciesTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/activityspeciesestype')}
        />
    </AdminLayout>
  );
};

export default ActivitySpeciesTypeCreate;